// @flow
import React, {Component} from 'react';

import PageTitle from '../components/PageTitle';
import {API_PORT, HOST, PATH_PREFIX} from "../env";
import {emoj, errorlog, renderlog, showlog} from "../utils";
import {EMOJ} from "../emoj";
import {PowerBIEmbed} from 'powerbi-client-react';
import {models} from "powerbi-client";
import "../style/power-bi.css";
import {WaitingOrNodataMessage} from "../components/waiting-or-nodata-message";

/**
 * /test-pbi-sirating
 */
export default class TestPowerBiSiRating extends Component {

    state = {
        wait: true,
        // accessToken: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Ik1yNS1BVWliZkJpaTdOZDFqQmViYXhib1hXMCIsImtpZCI6Ik1yNS1BVWliZkJpaTdOZDFqQmViYXhib1hXMCJ9.eyJhdWQiOiJodHRwczovL2FuYWx5c2lzLndpbmRvd3MubmV0L3Bvd2VyYmkvYXBpIiwiaXNzIjoiaHR0cHM6Ly9zdHMud2luZG93cy5uZXQvM2NlMTRiNTEtYTEzYS00MDJiLThkMTUtZGY0Y2E2N2VlZTQxLyIsImlhdCI6MTY0MTgxNDU3NywibmJmIjoxNjQxODE0NTc3LCJleHAiOjE2NDE4MTk4MjcsImFjY3QiOjAsImFjciI6IjEiLCJhaW8iOiJFMlpnWU5BN0tUWTVNTVU4WnQzYjc1SXQrUXkzREg5VXZPeG8ydDR4UlRGdDh3bDdvVDBBIiwiYW1yIjpbInB3ZCJdLCJhcHBpZCI6ImQ4NzgzZDc0LWIxNjItNGE4Zi04Y2FjLTc0OWM4NWRhNzg3MCIsImFwcGlkYWNyIjoiMSIsImZhbWlseV9uYW1lIjoiQnVmZmEiLCJnaXZlbl9uYW1lIjoiVmluY2Vuem8iLCJpcGFkZHIiOiI2Mi4xNDkuMTczLjE4NSIsIm5hbWUiOiJWaW5jZW56byBCdWZmYSIsIm9pZCI6Ijg3YWI5NDEyLTk5NTktNDIxNy05ZTc1LTRlMzQ3ZTBhZjE1YyIsInB1aWQiOiIxMDAzMjAwMTQyOEZGRDUzIiwicmgiOiIwLkFZRUFVVXZoUERxaEswQ05GZDlNcG43dVFYUTllTmhpc1k5S2pLeDBuSVhhZUhDQkFJay4iLCJzY3AiOiJBcHAuUmVhZC5BbGwgQ2FwYWNpdHkuUmVhZC5BbGwgQ2FwYWNpdHkuUmVhZFdyaXRlLkFsbCBDb250ZW50LkNyZWF0ZSBEYXNoYm9hcmQuUmVhZC5BbGwgRGFzaGJvYXJkLlJlYWRXcml0ZS5BbGwgRGF0YWZsb3cuUmVhZC5BbGwgRGF0YWZsb3cuUmVhZFdyaXRlLkFsbCBEYXRhc2V0LlJlYWQuQWxsIERhdGFzZXQuUmVhZFdyaXRlLkFsbCBHYXRld2F5LlJlYWQuQWxsIEdhdGV3YXkuUmVhZFdyaXRlLkFsbCBSZXBvcnQuUmVhZC5BbGwgUmVwb3J0LlJlYWRXcml0ZS5BbGwgU3RvcmFnZUFjY291bnQuUmVhZC5BbGwgU3RvcmFnZUFjY291bnQuUmVhZFdyaXRlLkFsbCBXb3Jrc3BhY2UuUmVhZC5BbGwgV29ya3NwYWNlLlJlYWRXcml0ZS5BbGwiLCJzdWIiOiJMOE1KQ1ViMUtqMGVORkhTSVNndUZobElCNnYwMDdxSVpPTFRLdWV1TExzIiwidGlkIjoiM2NlMTRiNTEtYTEzYS00MDJiLThkMTUtZGY0Y2E2N2VlZTQxIiwidW5pcXVlX25hbWUiOiJ2LmJ1ZmZhQGNhbmlub3NybC5pdCIsInVwbiI6InYuYnVmZmFAY2FuaW5vc3JsLml0IiwidXRpIjoieFBYTHBQa0lNa2FIR0Y0blNtaHBBQSIsInZlciI6IjEuMCIsIndpZHMiOlsiYjc5ZmJmNGQtM2VmOS00Njg5LTgxNDMtNzZiMTk0ZTg1NTA5Il19.xXl5uXcC6CAkXgEddxHrfT5Om6DwO8B_Gg5ZkndSaRwjrVFRbHyMURGJzNsSd6a3jsmNmaALJJLe3aG1sOtVVyKWqUapHFNGCuwbdRRhGWErqvYZKSBxP1OGWOmyZOeAZ0I7ZCrAqUNba8X6FIJQD_qrYLnJJEMBgGdy_S0o82SYh_Nnld3iQcuMoKX28mKxaEZ2CJpkG-G5iq9ZYkCexo1A_Ei6dIl3DDlk6PnsSKF0P32LvQZPVkFqAoT8Bbaja_U7ylTEnYlb9AqgmZB6BobSEeoXWzDpY_0UKH5YHVE6lzYnYBPz1aFbLW292O3QcA6ZDR7sU8bwB-fRqAOmLg"
        token: "",
        report:"",
        group:"",
    }

    constructor(props) {
        super( props );

        this.setParameter = this.setParameter.bind( this );

    }



    render() {


        renderlog("TestPBI", this.state, this.props);


        if( !this.state.wait /*&& this.state.loop < 5*/ ) {

            try {

                /**
                 *
                 * Navigate - The URL will be loaded into a new browsing context.
                 * NavigateAndRaiseEvent - The URL will be loaded into a new browsing context, and will raise a dataHyperlinkClicked event.
                 * RaiseEvent - Prevents the default behavior of URL click, and raise dataHyperlinkClicked event.
                 *
                 */
                let HyperlinkClickBehavior = {
                    Navigate: "Navigate",
                    NavigateAndRaiseEvent: "NavigateAndRaiseEvent",
                    RaiseEvent: "RaiseEvent"
                }



                const basicFilter/*: models.IBasicFilter*/ = {
                    $schema: "http://powerbi.com/product/schema#basic",
                    target: {
                        table: "Product",
                        column: "Count"
                    },
                    operator: "In",
                    values: [1,2,3],
                    filterType: 1 // pbi.models.FilterType.BasicFilter
                }


                let content = (
                    <PowerBIEmbed
                        embedConfig = {{
                            type: 'report',   // Supported types: report, dashboard, tile, visual and qna
                            // id: config.reports[0].id,
                            id: this.state.report,
                            //id: "6d57818e-92c2-48c9-9c2b-b785f1224576",

                            /*,
                             * In view mode the action bar is only supported for the embed for your organization scenario.
                             * For the action bar in view mode it’s recommended to enable UserState.ReadWrite.All permission
                             * for your Azure AD application.
                             * This permission is required to allow end users to add the report to their favorites, and for
                             * enabling personal bookmarks and persistent filters.
                             */
                            // embedUrl: config.reports[0].embedUrl + "&actionBarEnabled=true",    // alternativamente in viewMode
                            //embedUrl: "https://app.powerbi.com/reportEmbed?reportId=0d68cdf6-112f-4a18-a1c1-9453e91797eb&groupId=5c26eaf7-7a46-4fdb-b8f0-f58ebc1cffa5&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVdFU1QtRVVST1BFLUUtUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsibW9kZXJuRW1iZWQiOnRydWUsImFuZ3VsYXJPbmx5UmVwb3J0RW1iZWQiOnRydWUsImNlcnRpZmllZFRlbGVtZXRyeUVtYmVkIjp0cnVlLCJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZX19&filter=sr_reports_rating_criteria%2Fsr_evaluation_id eq 7&actionBarEnabled=false",    // alternativamente in viewMode
                            embedUrl: "https://app.powerbi.com/reportEmbed?reportId="+this.state.report+"/ReportSection88257cd20f6638d879ba&groupId="+this.state.group+"&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVdFU1QtRVVST1BFLUUtUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsibW9kZXJuRW1iZWQiOnRydWUsImFuZ3VsYXJPbmx5UmVwb3J0RW1iZWQiOnRydWUsImNlcnRpZmllZFRlbGVtZXRyeUVtYmVkIjp0cnVlLCJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZSwic2tpcFpvbmVQYXRjaCI6dHJ1ZX19",    // alternativamente in viewMode
                            //embedUrl:"https://app.powerbi.com/reportEmbed?reportId=6d57818e-92c2-48c9-9c2b-b785f1224576",
                            accessToken: this.state.token,


                            settings: {
                                panes: {
                                    filters: {
                                        expanded: false,        // possibilità di avere il flag
                                        visible: false
                                    },

                                    // configurazione dei panes
                                    bookmarks: {
                                        visible: false
                                    },
                                    fields: {
                                        // expanded: false,        // possibilità di avere il flag
                                        expanded: true
                                    },
                                    pageNavigation: {
                                        visible: false
                                    },
                                    selection: {
                                        visible: true
                                    },
                                    syncSlicers: {
                                        visible: true
                                    },
                                    visualizations: {
                                        // expanded: false,        // possibilità di avere il flag
                                        expanded: true
                                    }

                                },
                                //background: models.BackgroundType.Transparent,

                                /**
                                 * lingua
                                 *
                                 * Locale settings cannot be changed after the report is loaded.
                                 * To change the report locale settings, reset the iframe by calling powerbi.reset(element),
                                 * and then embed the report again.
                                 */
                                localeSettings: {
                                    language: "it",
                                    formatLocale: "it"
                                },

                                /**
                                 * visibilità dei bars
                                 */
                                bars: {
                                    actionBar: {
                                        visible: false
                                    }
                                },

                                /**
                                 * By default, the filter pane is visible.
                                 * However, you can hide this pane by using the filterPaneEnabled property
                                 */
                                filerPaneEnabled: true,

                                /**
                                 * By default, the page navigation arrows are visible on embedded reports.
                                 * However, you can hide these arrows by using the navContentPaneEnabled property
                                 *
                                 * The panes property replaces the navContentPaneEnabled property.
                                 * To maintain backward compatibility, the navContentPaneEnabled property still exists.
                                 * However, you should avoid using these two properties together.
                                 */
                                navContentPaneEnabled: true,

                                /**
                                 * The page navigation pane appears at the bottom of the report,
                                 * to use the new vertical pages pane you can set the position property
                                 *
                                 * It is not possible to change the position of the page navigation pane using updateSettings
                                 */
                                pageNavigation: {
                                    visible: true,
                                    // position: PagesPosition.Bottom     // TOOD trovare come importarlo
                                },


                                /**
                                 * You can control the behavior of a hyperlink in a table, or matrix out-of-the-box visuals.
                                 * By default, the hyperlink will open a new window
                                 *
                                 * A dataHyperlinkClicked event fires when a hyperlink is clicked on an out-of-the-box table or matrix visuals
                                 * and the behavior is either NavigateAndRaiseEvent or RaiseEvent
                                 *
                                 * Es.:
                                 * report.on('dataHyperlinkClicked', () => {
                                 *     ...
                                 * });
                                 */
                                // hyperlinkClickBehavior: HyperlinkClickBehavior.RaiseEvent,


                                /**
                                 * You can listen to an event for each rendered visual.
                                 * By default, the visual rendered events are disabled.
                                 *
                                 * If it is true, it make the visualRendered events triggered
                                 *
                                 * Es.:
                                 * report.on('visualRendered', () => {
                                 *     ...
                                 * });
                                 */
                                visualRenderedEvents: true,


                                /**
                                 * If you'd like to display customized error messages in embedded reports,
                                 * you can use the hideErrors property to hide the default Power BI embedded error messages.
                                 * Your code can then handle error events in a way that fits your app design.
                                 *
                                 * See Override default error messages for more information on overriding default errors
                                 */
                                hideErrors: false,


                                /**
                                 * You can control which page of your embedded report appears initially.
                                 * By default, the initial page is the page that you modified most recently,
                                 * which was the active page the last time you saved the report.
                                 * You can override this behavior by using the pageName property and supplying it
                                 * with the name of the page you'd like to display.
                                 * However, if no page with that name exists in Power BI, the request to open it fails
                                 */
                                pageName: 'Nome Pagina',


                                /**
                                 * You can control the filters that your app applies to an embedded report.
                                 * By default, the report initially uses the filters that you saved to the report.
                                 * However, you have two options if you want to adjust the filters
                                 */
                                filters: [
                                    // basicFilter
                                ],


                                /**
                                 * When you configure content to open in edit mode, assign the
                                 * permissions property a value that is appropriate for editing
                                 *
                                 *
                                 * The permissions value that you configure only works if the embed token that
                                 * you acquired has sufficient privileges.
                                 *
                                 * You can assign the viewMode property the following values:
                                 *     View - Opens the report in view mode.
                                 *     Edit - Opens the report in edit mode.
                                 *
                                 * You can assign the permissions property these values:
                                 *     Read - Users can view the report.
                                 *     ReadWrite - Users can view, edit, and save the report.
                                 *     Copy - Users can save a copy of the report by using Save As.
                                 *     Create - Users can create a new report.
                                 *     All - Users can create, view, edit, save, and save a copy of the report.
                                 *
                                 */
                                permissions: models.Permissions.All,
                                viewMode: models.ViewMode.Edit,

                                // commands: {
                                //     parameterPanel: {
                                //         enabled: true,
                                //         expanded: true
                                //     }
                                // },

                                extensions: [
                                    {
                                        command: {
                                            name: "campaign",
                                            title: "Start campaign",
                                            // icon: base64Icon,
                                            selector: {
                                                $schema: "http://powerbi.com/product/schema#visualSelector",
                                                visualName: "Nome"
                                            },
                                            extend: {
                                                visualOptionsMenu: {
                                                    title: "Start campaign",
                                                    menuLocation: models.MenuLocation.Top,
                                                }
                                            }
                                        }
                                    }
                                ]

                            }




                        }}

                        eventHandlers = {
                            new Map([
                                [
                                    'loaded',
                                    evt => {
                                        showlog('Report loaded');
                                        showlog(evt);

                                    }
                                ],
                                [
                                    'rendered',
                                    evt => {
                                        showlog('Report rendered');
                                        showlog(evt);
                                        // let models = window['powerbi-client'].models;
                                        // showlog("models");
                                        // showlog(models);

                                        showlog( window.report );
                                        showlog( window.report.getFilters );
                                        showlog( window.report.models );
                                        showlog( models );

                                        window.report.getFilters()
                                            .then( filters => {
                                                showlog("filters");
                                                showlog(filters);
                                            })
                                            .catch(e => {
                                                showlog("errore al getFilters", e);
                                            })
                                        ;

                                        HyperlinkClickBehavior = models.HyperlinkClickBehavior;



                                        /*
                                        showlog("avvio request accessToken");


                                        let formdata = new FormData();
                                        formdata.append("grant_type", "client_credentials");
                                        formdata.append("client_secret", "dwA7Q~FefMmz0KJmS-UoFl62l5LQQwwv7dXve");
                                        formdata.append("client_id", "d8783d74-b162-4a8f-8cac-749c85da7870");
                                        formdata.append("resource", "https://analysis.windows.net/powerbi/api");



                                        fetch(
                                            "https://login.microsoftonline.com/3ce14b51-a13a-402b-8d15-df4ca67eee41/oauth2/token",
                                            // "https://login.microsoftonline.com/3ce14b51-a13a-402b-8d15-df4ca67eee41/oauth2/token",
                                            {
                                                method: 'POST',
                                                headers: {
                                                    "Content-Type": "multipart/form-data;",
                                                    "Origin": "*"
                                                },
                                                body: formdata,
                                                redirect: 'follow',
                                                // mode: "cors",
                                                // credentials: "omit"
                                            }
                                        )
                                            .then(response => response.text())
                                            .then(result => {
                                                showlog("result");
                                                showlog(result);






                                            })
                                            .catch(error => {
                                                errorlog('error', error)
                                            });
                                            */




                                    }
                                ],
                                [
                                    'error',
                                    event => {
                                        showlog("error");
                                        showlog(event);
                                        showlog(event.detail);
                                    }
                                ],
                                [
                                    "saved",
                                    event => {
                                        showlog("saved");
                                        showlog(event);
                                    }
                                ],
                                [
                                    "saveAsTriggered",
                                    event => {
                                        showlog("saveAsTriggered");
                                        showlog(event);
                                    }
                                ],
                                [
                                    "dataSelected",
                                    event => {
                                        showlog("dataSelected");
                                        showlog(event);
                                    }
                                ],
                                [
                                    "buttonClicked",
                                    event => {
                                        showlog("buttonClicked");
                                        showlog(event);
                                    }
                                ],
                                [
                                    "filtersApplied",
                                    event => {
                                        showlog("filtersApplied");
                                        showlog(event);
                                    }
                                ],
                                [
                                    "pageChanged",
                                    event => {
                                        showlog("pageChanged");
                                        showlog(event);
                                    }
                                ],
                                [
                                    "commandTriggered",
                                    event => {
                                        showlog("commandTriggered");
                                        showlog(event);
                                    }
                                ],
                                [
                                    "swipeStart",
                                    event => {
                                        showlog("swipeStart");
                                        showlog(event);
                                    }
                                ],
                                [
                                    "swipeEnd",
                                    event => {
                                        showlog("swipeEnd");
                                        showlog(event);
                                    }
                                ],
                                [
                                    "bookmarkApplied",
                                    event => {
                                        showlog("bookmarkApplied");
                                        showlog(event);
                                    }
                                ],
                                [
                                    "dataHyperlinkClicked",
                                    event => {
                                        showlog("dataHyperlinkClicked");
                                        showlog(event);
                                    }
                                ],
                                [
                                    "visualRendered",
                                    event => {
                                        showlog("visualRendered");
                                        showlog(event);
                                    }
                                ],
                                [
                                    "visualClicked",
                                    event => {
                                        showlog("visualClicked");
                                        showlog(event);
                                    }
                                ],
                                [
                                    "selectionChanged",
                                    event => {
                                        showlog("selectionChanged");
                                        showlog(event);
                                    }
                                ],
                                [
                                    "renderingStarted",
                                    event => {
                                        showlog("renderingStarted");
                                        showlog(event);
                                    }
                                ]
                            ])
                        }

                        cssClassName = { "report-style-class" }

                        getEmbeddedComponent = { (embeddedReport) => {
                            window.report = embeddedReport;
                        }}
                    />
                );

                return content;

            }
            catch (e) {
                errorlog("render", e);
                return (
                    <div>{ emoj( EMOJ.angry_face ) }  Errore </div>
                )
            }


        }

        else {
            return (
                <React.Fragment>
                    <PageTitle
                        breadCrumbItems={[
                            {label: 'Welcome Page', path: '' + PATH_PREFIX + '/welcome'},
                            {label: 'Dashboard', active: true}
                        ]}
                        title={'SI Rating Dashboard'}
                    />


                    {
                        !!this.state.wait
                            ? (
                                <WaitingOrNodataMessage
                                    waiting={ !!this.state.wait }
                                    fullHeight={ true }
                                    nodataMessage={"Nessuna Valutazione"}
                                    waitingMessage={"Caricamento"}
                                />
                            )
                            : null
                    }




                </React.Fragment>
            );


        }




    }




    componentDidMount() {

        //this.getAccessToken();
        this.setParameter();


    }

    setParameter() {


        let _this = this;

        return new Promise(function (resolve, reject) {


             	fetch(HOST + API_PORT + "/PowerBI/publishReport",
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
                       },
						redirect: "follow",
						credentials: "include"
					}
				)
                .then(response => response.json())
                .then(result => {

                    _this.setState({
                        ..._this.state,
                        group: result.data.group,
                        report: result.data.report,
                        token: result.data.token,
                        wait: false
                    });


                })
                .catch(error => Promise.reject( error ))



        });
    }


    // getAccessToken() {

    //     let _this = this;

    //     return new Promise(function (resolve, reject) {


    //          	fetch(HOST + API_PORT + "/PowerBI/GetPowerBiToken",
	// 				{
	// 					method: "GET",
	// 					headers: {
	// 						"Content-Type": "application/json"
	// 					},
	// 					redirect: "follow",
	// 					credentials: "include"
	// 				}
	// 			)
    //             .then(response => response.text())
    //             .then(result => result)
    //             .then(result => {

    //                 showlog("result")
    //                 showlog(result);

    //                 _this.setState({
    //                     ..._this.state,
    //                     accessToken: result,
    //                     wait: false
    //                 });


    //             })
    //             .catch(error => Promise.reject( error ))



    //     });
    // }








};

